/* eslint-disable jsx-a11y/img-redundant-alt */
import { useState } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { WalletProvider } from '@solana/wallet-adapter-react';
import { WalletModalProvider } from '@solana/wallet-adapter-react-ui';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import Modal from 'react-modal';
import { wallets } from './config/web3';
import Home from './pages/home';
import CreatePoll from './pages/createPoll';
import StrawSoll from './pages/strawsoll';
import { WalletConnectProvider } from "./components/WalletConnectProvider";
import "./styles/globals.css";
import Video from './video/video.mp4';
import styled from 'styled-components';

const customStyle = {
  overlay: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
  },
  content: {
    background: "#45375a",
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 20px',
    gap: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    width: 'min(600px, 80%)',
    height: '650px',
    margin: 'auto'
  }
};

export const MainBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const VideoBg = styled.video`
  width: 100%;
  height: 100vh;
  -o-object-fit: cover;
  object-fit: cover;
  background: #232a34;
  &::-webkit-media-controls {
    display:none !important;
  }

  &::-webkit-media-controls-start-playback-button {
      display: none!important;
      -webkit-appearance: none;
  }
`;


function isMobile() {
  try {
    document.createEvent('TouchEvent')
    return true
  } catch (e) {
    return false
  }
}

function App() {
  const [open, setOpen] = useState(false);
  return (
    <WalletConnectProvider>
      <WalletProvider wallets={wallets} autoConnect>
        <WalletModalProvider>
          <Router>
            <div className="w-full top-14 flex justify-between px-5 md:px-20 pt-5 items-center">
              <MainBg>
                {isMobile() ?
                  <img src='/background.png' alt='Background Image' className='w-[100%] h-screen object-cover' />
                  :
                  <VideoBg playsInline autoPlay loop muted src={Video} type='video/mp4' />
                }
              </MainBg>
              <a href="/" className='relative'>
                <div className="p-1 rounded-lg overflow-hidden">
                  <img
                    src="/voting.png"
                    alt="Voting Logo"
                    className="h-22 w-auto md:h-28 lg:h-32 object-contain w-[100px] md:w-[150px]"
                  />
                </div>
              </a>
              <div className='lg:flex flex-col lg:flex-row relative'>
                <span
                  className="text-white font-semibold text-lg underline cursor-pointer pr-5 flex items-center"
                  onClick={() => setOpen(true)}
                >
                  How to use?
                </span>
                <WalletMultiButton />
              </div>

            </div>
            <Modal style={customStyle} isOpen={open} onRequestClose={() => setOpen(false)} >
              <h1 className="text-[2.75rem] text-[white] font-bold text-center sm:mb-[50px]">How To Use DAO</h1>
              <p className="text-lg text-justify">
                First of all, you'll have to install a solana wallet in your browser, like
                <a
                  href="https://phantom.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-500"
                >
                  {' '} Phantom. {' '}
                </a>
              </p>
              <p className="text-lg text-justify">
                Then, you need some $DAO tokens to participate to Voting. You can purchase this token on
                <a
                  href="https://raydium.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-500"
                >
                  {' '} Raydium {' '}
                </a>
                or
                <a
                  href="https://jup.ag"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-indigo-500"
                >
                  {' '} Jupiter. {' '}
                </a>
              </p>
              <p className="text-lg text-justify">
                Now that you have a fund-loaded wallet, connect it with our app, then you can create your poll or join a created poll by it's code.
              </p>
            </Modal>

            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route exact path="/create">
                <CreatePoll />
              </Route>
              <Route exact path="/soll/:strawsollId">
                <StrawSoll />
              </Route>
            </Switch>
          </Router>
        </WalletModalProvider>
      </WalletProvider>
    </WalletConnectProvider>
  );
}

export default App;
